import { Injectable } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';

import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from 'angularfire2/firestore';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromUI from '../store/actions/ui.action';

@Injectable()
export class AuthService {
  user: Observable<firebase.User>;
  constructor(
    private db: AngularFirestore,
    private firebaseAuth: AngularFireAuth,
    private store: Store<any>,
    private router: Router
  ) {
    this.user = firebaseAuth.authState;
  }

  signup(email: string, password: string) {
    this.firebaseAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then(value => {
        this.user
          .pipe(
            switchMap(auth => {
              if (auth) {
                return this.db
                  .collection(`/users`)
                  .doc(auth.uid)
                  .set({
                    uid: auth.uid,
                    email
                  });
              }
            })
          )
          .subscribe(() => {
            this.router.navigate(['/bookings']);
            this.store.dispatch(new fromUI.PageLoaded());
          });
      })
      .catch(err => {
        this.store.dispatch(new fromUI.ShowError(err.message));
      });
  }

  login(email: string, password: string) {
    return this.firebaseAuth.auth
      .signInWithEmailAndPassword(email, password);
  }

  resetPassword(email: string) {
    return this.firebaseAuth.auth
      .sendPasswordResetEmail(email);
  }

  logout() {
    return this.firebaseAuth.auth.signOut();
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/services/auth.service.ts